import React from "react";
import { Grid } from "@mui/material";
import translations from "../../config/language";

const language = process.env.REACT_APP_LANGUAGE;

const AccessToFinance = ({ selectedFarmer }) => {

    const accessToFinance = selectedFarmer.access_to_finance;
    return (
        <div className="user-profile">
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>
                    {translations[language].accessToFinance}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].loansFromGovernmentBank}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>{accessToFinance?.loan_from_gov_bank}</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].loansFromCommercialBank}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>{accessToFinance?.loan_from_comm_bank}</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].grantsFromINGOs}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>{accessToFinance?.grant_from}</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>
                    {translations[language].emergencyContactDetails}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].mobileNumber}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>{accessToFinance?.emergency_contact_detail}</Grid>
            </Grid>
        </div>
    );
};

export default AccessToFinance;